import React, { useState, useRef, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { ArrowLeft, User, ChevronLeft, } from 'react-feather';
import {
    Box,
    Button,
    TextField,
    Typography,
    Autocomplete,
    Switch,
    Avatar,
    FormControlLabel,
    Card,
    Radio,
    RadioGroup,
    Divider,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { Check } from 'react-feather';
import { authApi, formauthApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import Toastmessage from '../../components/Toast';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { format, isValid, parse } from 'date-fns';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';


export default function AddNewFrim() {
    const fileInputRef = useRef(null);
    const location = useLocation();
    const { firmId } = location.state || {};
    const [formData, setFormData] = useState({
        userName: '',
        owner: '',
        email: '',
        contactNumber: '',
        designation: '',
        registerNumber: '',
        address: '',
        city: '',
        state: { id: '', state_name: '', shortCode: '' },
        country: { id: 1, name: 'USA' },
        profile_image: '',
        pinCode: '',
        duration: '',
        selectedPlan: '',
        subscription_start_date: new Date(),
        PaymentStatus: '',
        paymentType: '',
        paymentDate: null,
        paymentTransaction: '',
        accountEmail: '',
        password: '',
        confirmPassword: '',
        isActive: false,
    });

    const [imageURL, setImageURL] = useState(null);
    const [selectedDuration, setSelectedDuration] = useState({})
    const [stateOptions, setStateOptions] = useState([]);
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(plans[0]?.id || '');
    const [errors, setErrors] = useState({});

    const [isLoading, setIsloading] = useState(false);

    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const handleSelectPlan = (planId) => {
        if (selectedPlan !== planId) {
            setSelectedPlan(planId);
            setSelectedDuration({}); // Reset radio button when a new card is selected
        }
    };

    const handleDurationChange = (planId, duration) => {


        setSelectedDuration(duration);

    };

    useEffect(() => {
        if (firmId) {
            fetchSubscription();
            listStates();
            viewClient(firmId)
        }

    }, [firmId]);

    const viewClient = async (firmId) => {
        const input_token = `${firmId}VIEW_FIRM`;
        const apiUrl = 'view_firm'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            id: firmId,
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {

                setSelectedPlan(data.data.subscription_id)
                setSelectedDuration(data.data.subscription_duration_id)
                setImageURL(data.data.firm_logo);
                setFormData(prevState => ({
                    ...prevState,
                    userName: data.data.firm_name,
                    id: data.data.id,
                    owner: data.data.firm_owner_name,
                    designation: data.data.firm_user_designation,
                    registerNumber: data.data.register_number,
                    email: data.data.email,
                    contactNumber: data.data.phone_number,
                    address: data.data.address,
                    city: data.data.locations[0]?.city,
                    state: {
                        id: data.data.locations[0]?.state_id,
                        state_name: data.data.locations[0]?.state_name,
                    },
                    pinCode: data.data.locations[0]?.zip_code,
                    country: { id: 1, name: data.data.country_code },
                    profile_image: data.data.firm_logo,
                    PaymentStatus: data.data.payments[0]?.payment_status,
                    paymentType: data.data.payments[0]?.payment_type,
                    paymentDate: dayjs(data.data.payments[0]?.date_of_payment).format("MM/DD/YYYY"),
                    paymentTransaction: data.data.payments[0]?.transaction_number,
                    password: data.data.password,
                    confirmPassword: data.data.password,
                    isActive: !!data.data.status
                }));;
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }


    const fetchSubscription = async () => {
        const input_token = 'SUBSCRIPTION_LIST'; // Replace with your actual token
        const apiUrl = 'list_of_subscription'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            status: 1
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setPlans(data.subscription_list)
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const listStates = async () => {
        const input_token = 'STATES'; // Replace with your actual token
        const apiUrl = 'list_of_states'; // Replace with the actual API endpoint

        const dataInput = {
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.list_of_states.map(state_id => ({
                    id: state_id.id,
                    state_name: state_id.state_name,
                    shortCode: state_id.state_short_code
                }));

                setStateOptions(statesArray);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    const handleChange = (field) => (event, value) => {
        setFormData({ ...formData, [field]: value ?? event.target.value });
    };

    const handleDateChange = (field, value) => {
        setFormData({
            ...formData,
            [field]: value,
        });
    };

    const handleActiveChange = (event) => {
        // setActive(event.target.checked);
        setFormData({ ...formData, isActive: event.target.checked });
    };
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageURL(reader.result);
                setFormData({ ...formData, profile_image: file }); // Set the file object in formData
            };
            reader.readAsDataURL(file);
        }
    };
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const validateForm = () => {
        const newErrors = {};
        const phoneNumberPattern = /^(?:\+1\s?)?(\d{10})$/; // Matches optional +1 or 1 followed by 10 digits

        // Client Name validation: Required and must be a string (letters and spaces only)
        if (!formData.userName || formData.userName.trim() === '') {
            newErrors.userName = "Firm name is required";
        } else if (!/^[a-zA-Z\s]+$/.test(formData.userName)) {
            newErrors.userName = "Firm name must contain only letters and spaces";
        } else if (formData.userName.length < 4) {
            newErrors.userName = "Firm Name must be at least 4 characters long";
        }

        // Firm owner Name validation: Required and must be a string (letters and spaces only)
        if (!formData.owner || formData.owner.trim() === '') {
            newErrors.owner = "Firm owner name is required";
        } else if (!/^[a-zA-Z\s]+$/.test(formData.owner)) {
            newErrors.owner = "Firm owner name must contain only letters and spaces";
        } else if (formData.owner.length < 4) {
            newErrors.owner = "Firm owner name must be at least 4 characters long";
        }

        // Email validation: Required and valid email format
        if (!formData.email || formData.email.trim() === '') {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Enter a valid email address";
        }

        // Contact Number validation: Required and must be numeric
        if (!formData.contactNumber || formData.contactNumber.trim() === '') {
            newErrors.contactNumber = "Contact number is required";
        } else if (!phoneNumberPattern.test(formData.contactNumber.replace(/\s+/g, ''))) {
            newErrors.contactNumber = "Contact number must be a valid 10-digit number (e.g., +1 1234567890)";
        }

        // designation validation
        if (!formData.designation || formData.designation.trim() === '') {
            newErrors.designation = "Designation is required";
        }

        // registerNumber validation
        if (!formData.registerNumber || formData.registerNumber.trim() === '') {
            newErrors.registerNumber = "RegisterNumber is required";
        }

        // Address validation
        if (!formData.address || formData.address.trim() === '') {
            newErrors.address = "Address is required";
        }

        // State validation
        if (!formData.state?.id || String(formData.state?.id).trim() === '') {
            newErrors.state = "State is required";
        }

        // City validation
        if (!formData.city || formData.city.trim() === '') {
            newErrors.city = "City is required";
        } else if (!/^[a-zA-Z\s]+$/.test(formData.city)) {
            newErrors.city = "City name must contain only letters and spaces";
        }

        // Zip Code validation (USA format)
        if (!formData.pinCode || formData.pinCode.trim() === '') {
            newErrors.pinCode = "Zip code is required";
        } else if (!/^\d{5}(-\d{4})?$/.test(formData.pinCode)) {
            newErrors.pinCode = "Invalid zip code format. It must be 5 digits or 5 digits followed by a hyphen and 4 digits (e.g., 12345 or 12345-6789).";
        }

        // PaymentStatus validation
        if (!formData.PaymentStatus || String(formData.PaymentStatus).trim() === '') {
            newErrors.PaymentStatus = "PaymentStatus is required";
        }

        // paymentType validation
        if (!formData.paymentType || String(formData.paymentType).trim() === '') {
            newErrors.paymentType = "Payment Type is required";
        }

        // paymentType validation
        if (!selectedPlan || String(selectedPlan).trim() === '') {
            Toastmessage("Please select a subscription plan.");
            newErrors.subcription = "Please select subscription plan.";
        }
        // paymentType validation
        if (!selectedDuration) {
            Toastmessage("Please select a valid duration.");
            newErrors.selectedDuration = "Please select subscription duration";
        }

        // paymentDate validation
        if (!formData.paymentDate || String(formData.paymentDate).trim() === '') {
            newErrors.paymentDate = "Payment Date is required";
        } else {
            // Attempt to parse the paymentDate if it's a string, or check its validity directly if it's a Date object
            let parsedDate;
            if (typeof formData.paymentDate === 'string') {
                parsedDate = new Date(formData.paymentDate); // Parse the string into a Date object
            } else {
                parsedDate = formData.paymentDate; // Assume it's already a Date object
            }

            if (!isValid(parsedDate)) {
                newErrors.paymentDate = "Invalid date. Please provide a valid date.";
            } else {
                // Format the date to MM/dd/yyyy to validate the format
                const formattedDate = format(parsedDate, 'MM/dd/yyyy');

                // Optionally validate the formatted string (e.g., if further checks are needed)
                const reParsedDate = parse(formattedDate, 'MM/dd/yyyy', new Date());
                if (!isValid(reParsedDate)) {
                    newErrors.paymentDate = "Invalid date format. Please use 'MM/dd/yyyy'.";
                }
            }
        }


        // paymentTransaction validation
        // if (!formData.paymentTransaction || String(formData.paymentTransaction).trim() === '') {
        //     newErrors.paymentTransaction = "Payment Transaction Type is required";
        // }

        // Password validation
        // if (!formData.password || formData.password.trim() === '') {
        //     newErrors.password = "Password is required";
        // } else if (formData.password.length < 6) {
        //     newErrors.password = "Password must be at least 6 characters";
        // }

        // // Confirm Password validation
        // if (!formData.confirmPassword || formData.confirmPassword.trim() === '') {
        //     newErrors.confirmPassword = "Confirm password is required";
        // } else if (formData.password !== formData.confirmPassword) {
        //     newErrors.confirmPassword = "Passwords do not match";
        // }

        // Image validation (optional field, but if provided, validate)
        if (!formData.profile_image) {
            const image = formData.profile_image;
            const validImageTypes = ['image/jpeg', 'image/png'];
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes

            if (!validImageTypes.includes(image.type)) {
                newErrors.profile_image = "Please upload a valid image (JPG, JPEG, PNG).";
            } else if (image.size > maxSize) {
                newErrors.profile_image = "Image size must be less than 2MB.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }



    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent defau
        // alt form submission behavior

        if (!validateForm()) {
            return; // Exit if validation fails
        }


        const addFirmApi = async () => {
            setIsloading(true);
            const input_token = firmId + 'UPDATE_FIRM';
            const apiUrl = 'update_firm';

            // Create a FormData object
            const formDataToSend = new FormData();
            // Append form fields
            formDataToSend.append('login_user_id', userID); // From login_user_id
            formDataToSend.append('id', formData.id);
            formDataToSend.append('firm_name', formData.userName);
            formDataToSend.append('firm_owner_name', formData.owner);
            formDataToSend.append('email', formData.email);
            formDataToSend.append('phone_number', formData.contactNumber);
            formDataToSend.append('register_number', formData.registerNumber);
            formDataToSend.append('firm_user_designation', formData.designation);
            formDataToSend.append('address', formData.address);
            formDataToSend.append('country_code', formData.country?.name);
            formDataToSend.append('state_id', formData.state?.id);
            formDataToSend.append('city', formData.city);
            formDataToSend.append('zip_code', formData.pinCode);
            formDataToSend.append('subscription_id', selectedPlan);
            formDataToSend.append('subscription_duration_id', selectedDuration);
            formDataToSend.append('subscription_start_date', dayjs(formData.subscription_start_date).format('DD-MM-YYYY'));
            formDataToSend.append('payment_type', formData.paymentType);
            formDataToSend.append('payment_status', formData.PaymentStatus);
            formDataToSend.append('date_of_payment', dayjs(formData.paymentDate).format('DD-MM-YYYY'));
            formDataToSend.append('transaction_number', formData.paymentTransaction);
            // formDataToSend.append('password', formData.password);
            formDataToSend.append('status', formData.isActive ? 1 : 0);

            if (formData.profile_image) {
                formDataToSend.append('profile_image', formData.profile_image);
            }
            try {
                const data = await formauthApi(input_token, formDataToSend, apiUrl, token, true);
               
                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate('/firmlist'));
                } else if (data && data.message === 'Token has expired') {
                    dispatch(logout());
                    setIsloading(false);
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false);
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false);
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false);
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addFirmApi()
    };

    const RequiredLabel = ({ children }) => (
        <>
            {children} <span style={{ color: 'red' }}>*</span>
        </>
    );

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
                className="title_head"
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={16} fontWeight={"bold"} color="var(--text-color)">
                        Update the Firm
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to='/firmlist'
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Firm list
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>

                {/* Header Section */}
                <Box className="sub-header">
                    <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                        <Link to="/firmlist" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                            <ArrowLeft size={20} style={{ marginRight: '8px' }} /> {/* Add margin for spacing */}
                            Firm Account Details
                        </Link>
                    </Typography>
                    <FormControlLabel
                        control={<Switch checked={formData.isActive} onChange={handleActiveChange} />}
                        label={
                            <Typography sx={{ color: formData.isActive ? 'green' : 'red', fontWeight: 'bold' }}>
                                Active : {formData.isActive ? 'Yes' : 'No'}
                            </Typography>
                        }
                    />
                </Box>
                {/* Form Fields */}
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>Firm Full Name</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the Firm Full Name"
                            error={!!errors.userName}
                            helperText={errors.userName} // Display error message
                            value={formData.userName}
                            onChange={handleChange('userName')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>Firm Owner Name</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the Firm Owner Name"
                            value={formData.owner}
                            error={!!errors.owner}
                            helperText={errors.owner} // Display error message
                            onChange={handleChange('owner')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>Firm User Email ID</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the Firm User Email ID"
                            value={formData.email}
                            disabled
                            error={!!errors.email}
                            helperText={errors.email} // Display error message
                            onChange={handleChange('email')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>Firm User Contact Number</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Firm Contact Number"
                            value={formData.contactNumber}
                            error={!!errors.contactNumber}
                            helperText={errors.contactNumber} // Display error message
                            onChange={handleChange('contactNumber')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>Firm User Designation</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Firm User Designation"
                            value={formData.designation}
                            error={!!errors.designation}
                            helperText={errors.designation} // Display error message
                            onChange={handleChange('designation')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>Firm Register Number</RequiredLabel> </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Firm Register Number"
                            value={formData.registerNumber}
                            error={!!errors.registerNumber}
                            helperText={errors.registerNumber} // Display error message
                            onChange={handleChange('registerNumber')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>Firm Street Address</RequiredLabel> </Typography>
                        <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            variant="outlined"
                            placeholder="Enter the Firm Street Address "
                            value={formData.address}
                            error={!!errors.address}
                            helperText={errors.address} // Display error message
                            onChange={handleChange('address')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <Typography>Firm Logo</Typography>
                        <Box display="flex" flexDirection="row" alignItems="center" gap={3}>
                            <Avatar
                                variant="rounded"
                                src={imageURL || ""}
                                sx={{ width: 100, height: 100, mb: 1 }}
                            />
                            <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
                                <input
                                    type="file"
                                    accept="image/jpeg, image/png"
                                    style={{ display: 'none' }}
                                    ref={fileInputRef}
                                    onChange={handleFileUpload}
                                />
                                <Button sx={{ backgroundColor: 'var(--back-button)', color: "var(--back-color)", fontWeight: "600", padding: "10px 20px" }} onClick={handleButtonClick}>
                                    Upload Image
                                </Button>
                                <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
                                    JPG or PNG no larger than 5 MB
                                </Typography>
                                {/* Display image error */}
                                {errors.profile_image && (
                                    <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                                        {errors.profile_image}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Country</RequiredLabel></Typography>
                        <Autocomplete
                            options={['USA']}
                            fullWidth
                            value="USA" // Set the default value here
                            disabled
                            onChange={handleChange('country')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Country"
                                    variant="outlined"
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>State</RequiredLabel></Typography>
                        <Autocomplete
                            options={stateOptions}
                            fullWidth
                            getOptionLabel={(option) => option.state_name}
                            value={formData.state} // Match by ID
                            error={!!errors.state}
                            helperText={errors.state} // Display error message
                            onChange={handleChange('state')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select State"
                                    variant="outlined"
                                    error={!!errors.state}
                                    helperText={errors.state} // Display error message
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>City</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the city name"
                            value={formData.city}
                            error={!!errors.city}
                            helperText={errors.city} // Display error message
                            onChange={handleChange('city')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Zip Code</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the Zip Code"
                            value={formData.pinCode}
                            error={!!errors.pinCode}
                            helperText={errors.pinCode} // Display error message
                            onChange={handleChange('pinCode')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid size={12}>
                        <Typography><RequiredLabel>Subscription Plan</RequiredLabel> </Typography>
                        <Box display="flex" gap={2} pt={1} sx={{ overflow: 'auto' }} >

                            {plans.map((plan) => (
                                <Card
                                    key={plan.id}
                                    onClick={() => handleSelectPlan(plan.id)}
                                    sx={{
                                        position: 'relative',
                                        padding: '10px 10px',
                                        boxShadow: 'none',
                                        minWidth: 300,
                                        border: selectedPlan === plan.id ? '2px solid #3570FF' : '1px solid var(--border-color)',
                                        borderRadius: 2,
                                        backgroundColor: selectedPlan === plan.id ? '#3570FF' : 'var(--back-button)',
                                        color: selectedPlan === plan.id ? '#fff' : 'var(--back-color)',
                                        cursor: 'pointer',
                                        marginBottom: '10px',
                                        '&:hover': {
                                            boxShadow: 3,
                                        },
                                    }}
                                    className="theme_bg-light text_all-white"
                                >
                                    <Typography sx={{ marginBottom: '10px' }} pb={0} fontWeight="bold">
                                        {plan.subscription_name}
                                    </Typography>
                                    <Box mt={1}>
                                        {plan.modules.map((feature, idx) => (
                                            <Typography
                                                key={idx}
                                                sx={{
                                                    color: selectedPlan === plan.id ? '#fff' : '#595A63',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginBottom: '5px',
                                                }}
                                                variant="body2"
                                            >
                                                <Check
                                                    size={12}
                                                    style={{
                                                        marginRight: 8,
                                                        color: '#C2C2C2',
                                                        backgroundColor: '#FFF',
                                                        border: '0.7px solid #C2C2C2',
                                                        borderRadius: '4px',
                                                    }}
                                                />
                                                {feature}
                                            </Typography>
                                        ))}
                                    </Box>
                                    <Divider component="li" sx={{ listStyle: 'none', marginTop: '15px' }} />
                                    <Box mt={2}>
                                        <Typography fontWeight="bold" mb={0.5} sx={{ fontSize: "0.8rem", color: selectedPlan === plan.id ? '#fff' : '#595A63' }}>
                                            Duration
                                        </Typography>
                                        <RadioGroup
                                            column
                                            value={selectedDuration || ''}
                                            onChange={(e) => handleDurationChange(plan.id, e.target.value)}
                                        >
                                            {plan.duration.map((duration) => (
                                                <FormControlLabel
                                                    key={duration.id}
                                                    value={duration.id}
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: selectedPlan === plan.id ? '#fff' : '#595A63',
                                                                '&.Mui-checked': {
                                                                    color: '#fff',
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                                                            <Typography
                                                                sx={{
                                                                    color: selectedPlan === plan.id ? '#fff' : '#595A63',
                                                                    fontSize: '0.9rem',
                                                                }}
                                                            >
                                                                {duration.duration_in_month + 'Month'} {/* Example: "1 Month" */}
                                                            </Typography>
                                                            <Typography
                                                                sx={{
                                                                    color: selectedPlan === plan.id ? '#fff' : '#595A63',
                                                                    fontSize: '0.9rem',
                                                                }}
                                                            >
                                                                {duration.discount_price} USD
                                                            </Typography>
                                                            <Typography
                                                                sx={{
                                                                    color: selectedPlan === plan.id ? '#e0e0e0' : '#c2c2c2',
                                                                    fontSize: '0.8rem',
                                                                    textDecoration: 'line-through',
                                                                }}
                                                            >
                                                                {duration.actual_price} USD
                                                            </Typography>
                                                        </Box>
                                                    }
                                                />
                                            ))}
                                        </RadioGroup>
                                    </Box>
                                </Card>
                            ))}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Payment status</RequiredLabel></Typography>
                        <Autocomplete
                            options={['SUCCESS', 'PAYMENT PENDING']}
                            fullWidth
                            value={formData.PaymentStatus}
                            onChange={handleChange('PaymentStatus')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Payment status"
                                    error={!!errors.PaymentStatus}
                                    helperText={errors.PaymentStatus} // Display error message
                                    variant="outlined"
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Payment Type</RequiredLabel></Typography>
                        <Autocomplete
                            options={['ONLINE', 'OFFLINE']}
                            fullWidth
                            value={formData.paymentType}
                            onChange={handleChange('paymentType')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Payment Type"
                                    variant="outlined"
                                    error={!!errors.paymentType}
                                    helperText={errors.paymentType}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />
                    </Grid>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <Typography><RequiredLabel>Payment Date</RequiredLabel></Typography>
                            <DatePicker
                                value={new Date(formData.paymentDate)}
                                error={!!errors.paymentDate}
                                helperText={errors.paymentDate}
                                onChange={(newValue) => handleDateChange('paymentDate', newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        variant="outlined"
                                        error={!!errors.paymentDate}
                                        helperText={errors.paymentDate}
                                        placeholder="Enter Payment Date"
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                    />
                                )}
                            />
                            {errors.paymentDate && (
                                <Typography color="error" sx={{ marginLeft: '10px', marginTop: '4px', fontSize: '12px' }}>
                                    {errors.paymentDate}
                                </Typography>
                            )}

                        </Grid>

                    </LocalizationProvider>

                    {/* <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Payment Transaction ID</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Payment Transaction ID"
                            value={formData.paymentTransaction}
                            error={!!errors.paymentTransaction}
                            helperText={errors.paymentTransaction} // Display error message
                            onChange={handleChange('paymentTransaction')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />

                    </Grid> */}
                    {formData.paymentType == 'ONLINE' && (
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <Typography>Payment Transaction ID</Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Enter Payment Transaction ID"
                                value={formData.paymentTransaction}
                                error={!!errors.paymentTransaction}
                                helperText={errors.paymentTransaction} // Display error message
                                onChange={handleChange('paymentTransaction')}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                            />
                        </Grid>
                    )}
                </Grid>
                <Box mt={4} textAlign="center">
                    <Button
                        type="submit"
                        onClick={handleSubmit}
                        disabled={isLoading}
                        variant="contained"
                        className='btn-theme-button'
                    >
                        Update Firm
                    </Button>
                </Box>
            </Box>
           
        </Box>

    );
}

